import React, {useEffect} from 'react'
import {useAppSelector} from '../../store/hooks'
import {selectIsAuthenticated} from '../../store/authSlice'
import {useNavigate, useSearchParams} from 'react-router-dom'
import Loader from '../common/Loader'
import {signOut} from 'aws-amplify/auth'

const SignOutPage = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      signOut().then(() => {
        navigate('/')
      })
    }
  }, [isAuthenticated])

  return (
    <div className="flex justify-center items-center h-screen">
      <Loader text="Signing out..." />
    </div>
  )
}

export default SignOutPage
